import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const Background = styled.a`
  display: inline;
`;

// prettier ignore is needed cuz otherwise prettier breaks into three lines and styled components can't read other styles
export const LogoWrapper = styled.div<{ newDesign: boolean }>`
  display: flex;
  justify-content: center;
  margin: 0.75rem 0;
  img {
    height: 1rem;
  }

  @media (min-width: ${breakpoints.lg}) {
    img {
      height: auto;
    }
    margin-top: 3.75rem;
    margin-bottom: 1.375rem;
  }
`;
